/*
  Copyright 2021-2022 Impact Observatory

  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed
  under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
  CONDITIONS OF ANY KIND, either express or implied. See the License for the
  specific language governing permissions and limitations under the License.
*/

import { BaseAPIService, metaDeserializer, RequestQuery } from './base/APIBase';

const fetchAnalysisById = async (id: string, query?: RequestQuery): Promise<any> => {
  return BaseAPIService.request(`/analysis/${id}`, { query }, metaDeserializer);
};

const fetchAnalyses = async (query?: RequestQuery): Promise<any> => {
  return BaseAPIService.request('/analysis', { query }, metaDeserializer);
};

const runAnalysis = async (id: string, data: any, query?: RequestQuery): Promise<any> => {
  return BaseAPIService.request(
    `/analysis/${id}/run`,
    {
      query,
      method: 'post',
      data,
    },
    metaDeserializer
  );
};

export { fetchAnalysisById, fetchAnalyses, runAnalysis };
